"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSearch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconSearch = function IconSearch(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M15.846 10.462a5.391 5.391 0 01-5.384 5.384 5.391 5.391 0 01-5.385-5.384 5.391 5.391 0 015.385-5.385 5.391 5.391 0 015.384 5.385zm6.154 10c0-.41-.168-.806-.445-1.082l-4.122-4.123a8.442 8.442 0 001.49-4.795A8.459 8.459 0 0010.462 2 8.459 8.459 0 002 10.462a8.459 8.459 0 008.462 8.461 8.445 8.445 0 004.795-1.49l4.123 4.11c.276.289.673.457 1.082.457A1.55 1.55 0 0022 20.462z"
  }));
};
exports.IconSearch = IconSearch;